import axiosInstance from "../../scenes/utils/axiosInstance";
import { API_ENDPOINTS } from "../../config/api";

export default class AiChatService {
  sendMessage = async ({ message, sessionId, analysisId, requestId, locale = "tr" }) => {
    const response = await axiosInstance.post(API_ENDPOINTS.AI.CHAT, {
      message,
      async: true,
      request_id: requestId,
      session_id: sessionId || undefined,
      locale,
      analysis_id: analysisId || undefined,
    });
    return response.data;
  };

  getLatestSession = async (analysisId) => {
    const response = await axiosInstance.get(API_ENDPOINTS.AI.CHAT_SESSION("latest"), {
      params: { analysis_id: analysisId || undefined },
    });
    return response.data;
  };

  getSession = async (sessionId) => {
    const response = await axiosInstance.get(
      API_ENDPOINTS.AI.CHAT_SESSION(sessionId)
    );
    return response.data;
  };
}
